import { Breadcrumbs } from "components/breadcrumbs";
import React, { useState, useEffect } from "react";
import EwaiverForm from "../components/form";
import { FullScreenLoading } from "components/fullScreenLoading";
import { DetailEwaiverType, useDetailEwaiver } from "../hooks/useDetailEwaiver";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useEditEwaiver } from "../hooks/useEditEwaiver";
import { EmailSectionItem, EwaiverUpdatePayload } from "../api";

const EwaiverEditPage = () => {
  const params = useParams();
  const navigate = useNavigate();

  const id = params?.id ?? "";

  const [defaultValues, setDefaultValues] = useState<any>(null);

  const { data, loading, fetchData } = useDetailEwaiver(id);
  const { editEwaiver, loading: isEditLoading } = useEditEwaiver();

  const getStatusValue = (isHaveOnlineCheckin: boolean | number | string) => {
    // Number case
    if (isHaveOnlineCheckin === 1) return true;
    if (isHaveOnlineCheckin === 0) return false;

    // String case
    if (isHaveOnlineCheckin === "1") return true;
    if (isHaveOnlineCheckin === "0") return false;

    // Boolean case
    if (isHaveOnlineCheckin === true) return true;
    if (isHaveOnlineCheckin === false) return false;

    return true;
  };

  const handleGetDetailEwaiver = async (data: DetailEwaiverType) => {
    // const MOCK_EWAIVER_FILE = new File(
    //   ["<html>Your HTML content here</html>"],
    //   "ewaiver.html",
    //   {
    //     type: "text/html",
    //   }
    // );

    // const MOCK_DATA = {
    //   is_active: true,
    //   event_id: "684fc6015678666ac876d5a5",

    //   start_date_time: "18/06/2025 16:23:00",
    //   end_date_time: "20/10/2025 09:30:00",
    //   authorization_form_url: "https://actiup.net/vi",
    //   disclaimer_form_url: "https://actiup.net/vi",

    //   banner_url: "https://pix.actiup.net/2025/07/03/1751533320281190/e1.jpg",

    //   // html_url:
    //   //   "https://pix.actiup.net/2025/06/25/1750819072308850/ewaiver_template.html",
    //   html_url: MOCK_EWAIVER_FILE,
    //   review_ewaiver_file: true,
    //   ewaiver_signature_required: false,
    //   send_email_to_authorizer: false,
    //   send_bib_via_email: true,
    //   change_pickup_method: true,
    //   max_pickup_method: 2,
    //   change_authorized_info: true,
    //   max_authorized_info: 5,
    //   authorize_only: true,

    //   event_infos: [
    //     {
    //       title_name_en: "EVENT 1",
    //       title_name_vi: "Thông tin sự kiện 1",
    //       status: true,
    //       type: "url",
    //       url: "https://actiup.net/vi",
    //     },
    //     {
    //       title_name_en: "EVENT 2",
    //       title_name_vi: "Thông tin sự kiện 2",
    //       status: false,
    //       type: "url",
    //       url: "https://actiup.net/en",
    //     },
    //     {
    //       title_name_en: "EVENT 3",
    //       title_name_vi: "Thông tin sự kiện 3",
    //       status: true,
    //       type: "images",
    //       images: [
    //         "https://pix.actiup.net/2025/06/27/1750995034671858/event_1.png",
    //         "https://pix.actiup.net/2025/06/27/1750995035601220/event_2.jpg",
    //       ],
    //     },
    //     {
    //       title_name_en: "EVENT 4",
    //       title_name_vi: "Thông tin sự kiện 4",
    //       status: true,
    //       type: "images",
    //       images: [
    //         "https://pix.actiup.net/2025/06/27/1750995090286412/event_3.jpg",
    //         "https://pix.actiup.net/2025/06/27/1750995091296208/event_4.jpg",
    //       ],
    //     },
    //   ],

    //   use_ekyc: false,
    //   ekyc_orc_limit: 0,
    //   ekyc_face_matching_limit: 0,
    //   ekyc_face_matching_ratio: 0,
    // };

    const formatEmailSection: {
      title_name_vi: string;
      title_name_en: string;
      status: boolean;
      type: string;
      url?: string;
      images?: string[];
    }[] = [];

    data?.email_section?.forEach((item) => {
      if (item.type === "url") {
        formatEmailSection.push({
          title_name_en: item.title_en,
          title_name_vi: item.title_vi,
          type: "url",
          url: item?.value[0] ?? "",
          status: item?.show,
        });
      }

      if (item.type === "image") {
        formatEmailSection.push({
          title_name_en: item.title_en,
          title_name_vi: item.title_vi,
          type: "images",
          images: item?.value ?? [],
          status: item?.show,
        });
      }
    });

    const formatData = {
      is_active: getStatusValue(data?.is_have_online_checkin),
      event_id: data?.event_id,

      start_date_time: dayjs(data?.start_checkin_online_date).format(
        "DD/MM/YYYY HH:mm:ss"
      ),
      end_date_time: dayjs(data?.end_checkin_online_date).format(
        "DD/MM/YYYY HH:mm:ss"
      ),
      authorization_form_url: data?.authorization_form_url ?? "",
      disclaimer_form_url: data?.disclaimer_form_url ?? "",
      t_and_c_link: data?.t_and_c_link ?? "",

      banner_url: data?.ewaiver_banner_url ?? "",

      html_url: data?.url_html ?? undefined,
      // html_url: "https://pix.actiup.net/2025/06/25/1750819072308850/ewaiver_template.html",

      ewaiver_signature_required: data?.waiver_sign_required,
      send_email_to_authorizer: data?.is_sent_to_authorizer,
      send_bib_via_email: data?.send_bib_via_email,
      is_show_send_ewaiver: data?.is_show_send_ewaiver ?? false,
      is_show_send_qrcode: data?.is_show_send_qrcode ?? false,
      change_pickup_method: data?.is_change_pickup_method,
      max_pickup_method: data?.number_of_times_change_pickup ?? 1,
      change_authorized_info: data?.is_change_authorized_info,
      max_authorized_info: data?.number_of_times_update_authorized_info ?? 1,
      authorize_only: data?.only_authorize,

      event_infos: formatEmailSection,

      use_ekyc: data?.kyc_required,
      ekyc_orc_limit: data?.kyc_ocr_limit,
      ekyc_face_matching_limit: data?.kyc_face_matching_limit,
      ekyc_face_matching_ratio: data?.kyc_face_matching_ratio,
    };

    console.log("ORIGINAL DATA:", data);
    console.log("FORMAT DATA:", formatData);

    setDefaultValues(formatData);
  };

  const handleSubmit = async (data: any) => {
    try {
      const email_section: EmailSectionItem[] = [];

      data?.event_infos?.forEach((item: any) => {
        // if (!item.status) return;

        if (item.type === "url" && item.url) {
          email_section.push({
            title_en: item.title_name_en,
            title_vi: item.title_name_vi,
            type: "url",
            value: [item.url],
            show: item.status,
          });
        }

        if (item.type === "images" && item.images?.length > 0) {
          email_section.push({
            title_en: item.title_name_en,
            title_vi: item.title_name_vi,
            type: "image",
            value: item.images,
            show: item.status,
          });
        }
      });

      const payload: EwaiverUpdatePayload = {
        event_id: data?.event_id,
        is_have_online_checkin: data?.is_active,
        start_checkin_online_date: dayjs(
          data.start_date_time,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss"),
        end_checkin_online_date: dayjs(
          data.end_date_time,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss"),

        authorization_form_url: data?.authorization_form_url,
        disclaimer_form_url: data?.disclaimer_form_url,
        t_and_c_link: data?.t_and_c_link,
        ewaiver_banner_url: data?.banner_url,

        ewaiver_file: data?.html_url,
        delete_file: data?.html_url ? false : true,

        waiver_sign_required: data?.ewaiver_signature_required,
        is_sent_to_authorizer: data?.send_email_to_authorizer,
        send_bib_via_email: data?.send_bib_via_email,
        is_show_send_ewaiver: data?.is_show_send_ewaiver ?? false,
        is_show_send_qrcode: data?.is_show_send_qrcode ?? false,

        is_change_pickup_method: data?.change_pickup_method,
        number_of_times_change_pickup: data?.max_pickup_method ?? 0,

        is_change_authorized_info: data?.change_authorized_info,
        number_of_times_update_authorized_info: data?.max_authorized_info ?? 0,

        only_authorize: data?.authorize_only,

        email_section,

        kyc_required: data?.use_ekyc,
        kyc_ocr_limit: data?.ekyc_orc_limit,
        kyc_face_matching_limit: data?.ekyc_face_matching_limit,
        kyc_face_matching_ratio: data?.ekyc_face_matching_ratio,
      };

      const res = await editEwaiver(id, payload);

      console.log("eWaiver edit form submit:", payload);
      console.log("eWaiver edit res:", res);

      toast.success("Successfully Edited");

      // Redirect to detail page
      navigate(`/ewaiver`);
    } catch (error) {
      console.error(`Edit e-waiver failed:`, error);
    }
  };

  useEffect(() => {
    if (data) handleGetDetailEwaiver(data);
  }, [data]);

  return (
    <div className="wrapper">
      {(loading || isEditLoading) && <FullScreenLoading />}
      <Breadcrumbs customPageLabel="Edit New eWaiver" />
      {!loading && defaultValues && (
        <EwaiverForm
          defaultValues={defaultValues}
          loading={isEditLoading}
          onFormSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default EwaiverEditPage;
